var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfGreenSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 122,
    viewBox: "0 0 240 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.7 118.9L240 100.6L194 97.9L197.7 118.9ZM192 92.5L225.5 60.9L181.4 74.1L192 92.5ZM177.7 69.6L198.3 28.4L161.3 55.9L177.7 69.6ZM156.4 53.1L161.7 7.29999L136.4 45.8L156.4 53.1ZM109.4 44.8H130.7L120.1 0L109.4 44.8ZM83.7 53.1L103.7 45.8L78.4 7.29999L83.7 53.1ZM78.6 56L41.6 28.5L62.2 69.7L78.6 56ZM58.6 74.1L14.5 60.9L48 92.5L58.6 74.1ZM46 97.9L0 100.6L42.3 118.9L46 97.9ZM55.4 121.8H184.7C184.7 86.1 155.8 57.2 120.1 57.2C84.4 57.2 55.4 86.1 55.4 121.8Z",
    fill: "#8DD4AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfGreenSun);
export default __webpack_public_path__ + "static/media/HalfGreenSun.525ee6bc9e86b1298f020c8fc2b4a61e.svg";
export { ForwardRef as ReactComponent };